import constants from "./constants"
import router from "@/router"

export default {
    Resources: {
        getUnsplashImage(w, h) {            
            let themes;
            // Thème specifiques en fonction des périodes de l'année
            const date = new Date();
            if (date.getMonth() == 0) {
                themes = ["happy-new-year", date.getFullYear().toString(), "winter"];
            } else if (date.getMonth() == 2) {
                themes = ['spring'];
            } else if (date.getMonth() == 5) {
                themes = ['summer'];
            } else if (date.getMonth() == 8) {
                themes = ['autumn'];
            } else if (date.getMonth() == 11) {
                themes = [date.getDate() < 20 ? 'winter' : 'christmas'];
            } else {
                themes = [
                'nature',
                'architecture',
                'office',
                'sport',
                'animals',
                'travel',
                'cars',
                'arts-culture'
                ];
            }
            const idx = Math.floor(Math.random() * Math.floor(themes.length));
            const clientId = '9b06b47954536190011a77c9d3a4a591339e48ec769f00f5faa2f1256d286b61';
            const url = `https://api.unsplash.com/photos/random?query=${themes[idx]}&w=${w.toString()}&h=${h.toString()}&client_id=${clientId}`;                
            return fetch(url)
                .then(response => response.json())
                .then(data => data && data.urls ? data.urls.regular : null)
                .catch(() => null)      
        },
        exportData(arrayHeader, arrayData, delimiter, fileName) {
            let header = arrayHeader.join(delimiter) + '\n';
            let csv = header;
            arrayData.forEach( array => {
                csv += array.join(delimiter)+"\n";
            });
 
            let csvData = new Blob([csv], { type: 'text/csv' });  
            let csvUrl = URL.createObjectURL(csvData);
 
            let hiddenElement = document.createElement('a');
            hiddenElement.href = csvUrl;
            hiddenElement.target = '_blank';
            hiddenElement.download = fileName + '.csv';
            hiddenElement.click();
        }
    },
    Date: {
        toUnixTimestamp(date) {
            let d = date.getTime()
            let now = new Date()
            let offset = now.getTimezoneOffset() * 60 * 1000 // now in milliseconds
            return d + offset
        }
    },
    Vehicles: {
        getStatusColor(status) {
            let color = status === undefined ? '' : 'transparent'
            if (status == 0) color = 'blue'
            else if (status == 2) color = 'red'            
            return color
        },
        getStatusLabel(status) {
            let label = ''
            if (status == 0) label = 'En commande'
            else if (status == 2) label = 'Hors parc'            
            return label
        },
        getEnergyLabel: function(id) {
            let label = ''
            let energy = constants.vehicleModifications.ENERGIES.find(el => el.id === id)
            if (energy !== undefined) label = energy.label

            return label
        },
        // Conso mixte d'une motorisation : valeur fournie, sinon moyenne ville/route
        getMixteConsumption: function(modification) {
            if (!modification) return 0
            if (modification.mixte) return modification.mixte
            if (modification.city && modification.highway) return Math.round((modification.city + modification.highway) / 2 * 100) / 100
            return 0
        }
    },
    Leases: {
        getClosureStatusColor(rest) {
            let color = rest === undefined ? '' : 'green'
            if (rest <= 0) color = 'black'
            else if (rest <= 3) color = 'red'
            else if (rest <= 6) color = 'orange'
            else if (rest <= 12) color = 'yellow'
            
            return color
        },
        getStatusColor(status) {
            let color = status === undefined ? '' : 'green'
            if (status == 1) color = 'orange'
            else if (status == 2) color = 'red'
            else if (status == 3) color = 'blue'
            return color
        },
        getStatusLabel(status) {
            let label = 'En cours'
            if (status == 1) label = 'A renouveller'
            else if (status == 2) label = 'Echu'
            else if (status == 3) label = 'Renouvellement en cours'                
            return label
        }
    },
    getStatusColor(status) {
        let color = ''
        switch (status) {
            case 0:                
                color = constants.colors.STATUS_NEW                    
                break
            case 10:
                color = constants.colors.STATUS_RECEIVED                    
                break
            case 15:
                color = constants.colors.STATUS_RECALLED     
                break
            case 20:
                color = constants.colors.STATUS_PROCESSING                    
                break
            case 30:
                color = constants.colors.STATUS_WAITING                   
                break
            case 40:
                color = constants.colors.STATUS_WAITING_INFOS                    
                break
            case 50:
                color = constants.colors.STATUS_WAITING_PROVIDER_INFOS                    
                break
            case 60:
                color = constants.colors.STATUS_COMPLETED                    
                break
            case 70:
                color = constants.colors.STATUS_CANCELED                    
                break
            case 80:
                color = constants.colors.STATUS_REFUSED                    
                break
            case 90:
                color = constants.colors.STATUS_ARCHIVED              
                break
            default:
                color = "#000000"
                break

        }   
        
        return color
    },
    getStatusLabel(status) {
        let label = ''
        switch (status) {
            case 0:                
                label = "Nouveau"                    
                break
            case 10:
                label = "Reçu"                   
                break
            case 15:
                label = "Relancé"                   
                break
            case 20:
                label = "En cours"                    
                break
            case 30:
                label = "En attente"                   
                break
            case 40:
                label = "En attente d'information"                    
                break
            case 50:
                label = "En attente d'information fournisseur"                   
                break
            case 60:
                label = "Terminé"                    
                break
            case 70:
                label = "Annulé"                  
                break
            case 80:
                label = "Refusé"                
                break
            case 90:
                label = "Archivé"                
                break
            default:
                label = "Aucun"
                break

        }   
        
        return label
    },
    async notifyIncomingCall(ev) {
    if (!("Notification" in window)) {
        console.warn("Notifications non supportées par ce navigateur.");
        return false;
    }

    if (!window.isSecureContext) {
        console.warn("Notifications nécessitent HTTPS (secure context).");
        return false;
    }

    // Ne PAS demander ici si ce n’est pas un geste utilisateur
    if (Notification.permission !== "granted") {
        console.warn("Permission non accordée. Demande via un bouton utilisateur.");
        return false;
    }
    let title = "☎️ Appel entrant";
    let message = `${ev.firstname} ${ev.lastname}`;
    if (ev.customer && ev.customer.length > 0) {
        message += `\n🧰: ${ev.customer})`;
    }
    if (ev.phone && ev.phone.length > 0) {
        title += ` ${ev.phone}`;
    }

    // Afficher la notification avec logo Ask
    const n = new Notification(title, {
        body: message,
        icon: '/images/askme.png',        
    });
    
    n.onclick = () => {    
        window.focus();
        n.close();
        const targetId = ev && ev.id !== undefined ? ev.id : undefined;
        if (targetId === undefined || targetId === null) return;
        
        if (!router) return;
        router.push({
            name: "Profile",
            params: {
                id: targetId,
                tab: "tab-1"
            }
        });
    };

    return true;
    },
    // Ouvre un devis dans un nouvel onglet. Le fichier passe par l'API avec le jeton :
    // un simple lien n'est plus accepté (les devis ne sont plus téléchargeables sans authentification).
    openQuotation(http, file) {
        const tab = window.open('', '_blank')
        http.get(`download/quotation/${encodeURIComponent(file)}?inline`, { responseType: 'blob' })
            .then(response => {
                const url = URL.createObjectURL(response.data)
                if (tab) tab.location.href = url
                else window.open(url, '_blank')
                setTimeout(() => URL.revokeObjectURL(url), 60000)
            })
            .catch(() => {
                if (tab) tab.close()
            })
    },
    startSSEConnection(vm) {
        let es = new EventSource(
            "https://backoff.askme-app.fr/sse.php",
            { withCredentials: true }
        );

        es.addEventListener("screenpop", (e) => {
            const data = JSON.parse(e.data);              
            vm.$root.$emit('serverNotification', data);
        });
        return es; 
    }
}
